import { Card } from "@emanprague/ppaskit";
import React from "react";
import styles from "./style.module.scss";

const GeneralSettingCard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Card>
      <Card.Body>
        <div className={styles.generalSettingCard}>{children}</div>
      </Card.Body>
    </Card>
  );
};

export default GeneralSettingCard;
